import {isBrowser} from '@vio/core/src/_web/utils/environment'
import {
  safelyGetStorageItem,
  safelySetStorageItem
} from '@vio/core/src/_web/utils/persistence'

export const IN_APP_FIRST_STICKY_STORAGE_KEY = 'inAppFirst'
const STICKY_VALUE = '1'

const isStickyValue = (value: string | null | undefined): boolean =>
  value === STICKY_VALUE

/**
 * Reads the sticky InAppFirst flag from `sessionStorage`, the single source of
 * truth.
 *
 * `sessionStorage` is natively tab-scoped: it persists across in-tab
 * navigations but a freshly-opened tab starts empty, so the mode can never leak
 * into the user's other browser sessions. There is intentionally no cookie
 * mirror — the server cannot read this, so SSR always treats a request as
 * non-sticky (the first in-app entry still renders flash-free because that load
 * carries the `inAppFirst` URL param, which the `getHasInAppFirstSignal`
 * selector reads directly).
 */
export const hasStickyInAppFirst = (): boolean => {
  if (!isBrowser) return false

  return isStickyValue(
    safelyGetStorageItem(
      'sessionStorage',
      IN_APP_FIRST_STICKY_STORAGE_KEY,
      'hasStickyInAppFirst: sessionStorage read failed'
    )
  )
}

/**
 * Writes the sticky flag to `sessionStorage`. It lives for the tab session and
 * dies when the tab closes — no cookie, no cross-tab bleed.
 */
export const setStickyInAppFirst = (): void => {
  if (!isBrowser) return

  safelySetStorageItem(
    'sessionStorage',
    IN_APP_FIRST_STICKY_STORAGE_KEY,
    STICKY_VALUE,
    'setStickyInAppFirst: sessionStorage write failed'
  )
}
